import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import qs from 'qs';
import { Observable } from 'rxjs';
import PaginatedResponse from '../models/baseModels/paginatedResponse';
import BaseResponse from '../models/baseModels/baseResponse.model';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseCrudService<T> {
  abstract controller: string;
  protected httpClient = inject(HttpClient);

  constructor() {}

  getPaginated<Y = T>(params?: object, endpoint = '') {
    const queryParams = params ? '?' + qs.stringify(params) : '';

    const response = this.httpClient.get<PaginatedResponse<Y[]>>(
      `${this.controller}${endpoint ? '/' + endpoint : ''}${queryParams}`,
    );

    return response;
  }

  get<Y = T>(params?: object, endpoint = '') {
    const queryParams = params ? '?' + qs.stringify(params) : '';

    // @ts-ignore
    const response = this.httpClient.get<BaseResponse<Y>>(
      `${this.controller}${endpoint ? '/' + endpoint : ''}${queryParams}`,
    );

    return response;
  }

  create<Y = T, R = T>(
    body: Y,
    endpoint = '',
    params?: object,
    useData = true,
  ) {
    const queryParams = params ? '?' + qs.stringify(params) : '';

    let data: any = body;

    if (useData) {
      data = { data: body };
    }

    // @ts-ignore
    const response = this.httpClient.post<BaseResponse<R>>(
      `${this.controller}/${endpoint}${queryParams}`,
      data,
    );

    return response;
  }

  upload<Y>(file: File, endpoint: string = ''): Observable<Y> {
    let formData: FormData = new FormData();

    formData.append(`File`, file);

    return this.httpClient.put<Y>(endpoint ? endpoint : 'upload', formData);
  }
}
